// extracted by mini-css-extract-plugin
export default {"list":"vg zd"};